import api from '~services/axios';

export default {

  // 1、合同列表数据字典项下拉框查询
  apiGetInsideCategoryData: params =>
    api.get('/api/crmcontract/queryContractDictionaryList', { params }),

  // 2、合同详情-对方公司列表查询
  apiGetInsideCmpanyInfo: params =>
    api.get('/api/crmcontract/query/contractOtherCmpanyInfo', { params }),

  // 3、合同详情-补充协议列表查询
  apiGetInsideSupplement: params =>
    api.get('/api/crmcontract/query/contractSupplement', { params }),

  // 4、合同详情-续签协议列表查询
  apiGetInsideContractRenewal: params =>
    api.get('/api/crmcontract/query/contractRenewal', { params }),

  // 5、合同详情-异常提报记录列表查询
  apiGetInsideAbnormalReportRecord: params =>
    api.get('/api/crmcontract/query/contractAbnormalReportRecord', { params }),

  // 6、合同详情-调档记录列表查询
  apiGetInsideShiftRecord: params =>
    api.get('/api/crmcontract/query/contractShiftRecord', { params }),

  // 7、合同详情-保证金/押金列表查询
  apiGetInsideContractsBond: params =>
    api.get('/api/crmcontract/query/contractsBond', { params }),

  apiUpdateSalesman: params =>
    api.post('/api/crmcontract/updateSalesman', params),

  deleteCrmcontract: params =>
    api.post('/api/crmcontract/delete', params),

  // 校验回款金额总和不大于回款计划金额（新增修改时调用）
  apiGetContractShiftRecord: params =>
    api.get('/api/receivablePlan/checkReceivableAmount', { params }),

  // 合同详情-开票记录列表查询(内部)
  crmInvoiceRecordInvoice: params =>
    api.get('/api/crmInvoiceRecord/query/invoice', { params }),

  // 选择已有开票查询接口
  queryInvoiceFromOa: params =>
    api.get('/api/crmInvoiceRecord/queryInvoiceFromOa', { params }),

  // 保存已有开票信息
  crmInvoiceRecordSaveInvoice: params =>
    api.post('/api/crmInvoiceRecord/saveInvoice', params),

  // 合同验收列表查询
  crmAcceptanceRecordList: params =>
    api.get('/api/crmAcceptanceRecord/queryList', { params }),

  // 已有验收记录查询
  queryAcceptanceFromOaList: params =>
    api.get('/api/crmAcceptanceRecord/queryAcceptanceFromOa', { params }),

  // 已有验收记录保存
  saveAcceptance: params =>
    api.post('/api/crmAcceptanceRecord/saveAcceptance', params),

  // 验收记录删除
  deleteAcceptance: params =>
    api.post('/api/crmAcceptanceRecord/delete/acceptance', params),

  // 验收查询统计
  crmAcceptanceRecordCount: params =>
    api.get('/api/crmAcceptanceRecord/query/count', params),

  // 开票查询统计
  crmInvoiceRecordCount: params =>
    api.get('/api/crmInvoiceRecord/query/count', params),

};
